<script>
	import { getters, namespace } from "User/store/store";
	import { mapGetters } from "vuex";
	import ApiRequest from "Api/request";

	const request = new ApiRequest();
	const feedbackUrl = "/api/profile/feedbackMessage";

	export default {
		name: "feedback-modal",
		data() {
			return {
				sendOk: false,
				feedbackType: "",
				feedbackPriority: "",
				subject: "",
				description: "",
				feedbackSendingError: null,
				relatedTicketId: null,
				isSendingProcess: false
			};
		},
		computed: {
			...mapGetters(namespace, {
				userName: getters.userName.name
			})
		},
		methods: {
			async sendRequest() {
				this.feedbackSendingError = null;
				this.sendOk = false;
				this.isSendingProcess = true;

				if (!this.formValid()) {
					this.feedbackSendingError = "Проверьте правильность заполнения формы.";
					return;
				}

				let message = {
					UserEmail: this.userName,
					Subject: this.subject,
					Priority: this.feedbackPriority,
					Type: this.feedbackType,
					Description: this.description,
					RelatedTicketId: this.relatedTicketId
				};
				await request.postData(feedbackUrl, message)
					.then((response) => {
						if (response.success) {
							let result = JSON.parse(response.value);
							if (result.Error === null) {
								this.sendOk = true;
								this.description = "";
								this.feedbackType = "";
								this.feedbackPriority = "";
								this.subject = "";
							} else {
								this.feedbackSendingError = result.Error;
							}
						}
						this.isSendingProcess = false;
					});
			},
			formValid() {
				const subjectValid = document.getElementById("ticket-subject").checkValidity();
				const typeValid = document.getElementById("ticket-type").checkValidity();
				const priorityValid = document.getElementById("ticket-priority").checkValidity();
				const descriptionValid = document.getElementById("ticket-description").checkValidity();

				return subjectValid &&
					typeValid &&
					priorityValid &&
					descriptionValid;
			}
		}
	}
</script>